import "./index.css";
import GdnAdTemplate from "../GdnAdTemplate";

/**
 * Google Display Network — 300×600 half-page (rendered @2× = 600×1200).
 * Stacked logo (product icon + name over "JETBRAINS <family>"); shared body
 * in ../GdnAdTemplate.
 */
const HalfPageAds = ({id, zoom}) => <GdnAdTemplate id={id} zoom={zoom} variant="stacked" />;

export default HalfPageAds;
